import { useEffect } from "react";
import loadBackboneApp from "../../../../app/load-backbone-app";
import api from "../../../..//core/api/api";
import { SetupView } from "../../../../app/components/alertmanager/alertmanager";
import { ALERT_TYPE } from "../../../../app/components/alertmanager/alert-utils";
import AlertManagerRoot from "../alert-manager-root";

function SlackSetup() {
    useEffect(() => {
        api.getSlackConfigStatus()
            .then(slackConfigStatus => {
                if (slackConfigStatus === "SLACK_CONFIGURED") {
                    api.getSlackConfig().then(res => {
                        loadBackboneApp(
                            // @ts-ignore
                            new SetupView({
                                type: ALERT_TYPE.SLACK,
                                existingConfigDtls: res || null
                            })
                        );
                    });
                } else {
                    loadBackboneApp(
                        // @ts-ignore
                        new SetupView({
                            type: ALERT_TYPE.SLACK,
                            existingConfigDtls: null
                        })
                    );
                }
            })
            .fail(() => {
                console.error("Error retrieving Slack configuration status");
            });
    }, []);

    return <></>;
}

export default function() {
    return (
        <AlertManagerRoot>
            <SlackSetup />
        </AlertManagerRoot>
    );
}
